/**
 * @file Contributor assignment related fragments.
 */

import gql from 'graphql-tag';

export const ContributorAssignmentShareBaseDetails = gql`
  fragment ContributorAssignmentShareBaseDetails on ContributorAssignmentShare {
    id
    upload_access
    view_access
    album_create_access
    video_upload_access
    email_address
    phone_number
    album_folder {
      id
      name
      is_root
    }
    album {
      id
      name
    }
  }
`;

export const ContributorAssignmentBaseDetails = gql`
  fragment ContributorAssignmentBaseDetails on ContributorAssignment {
    id
    upload_access
    view_access
    album_create_access
    video_upload_access
    account {
      id
      email_address
      phone_number
    }
    album_folder {
      id
      name
      is_root
    }
    album {
      id
      name
    }
    account_display_name
    contributor_assignment_share {
      id
      ...ContributorAssignmentShareBaseDetails
    }
  }
  ${ContributorAssignmentShareBaseDetails}
`;

export const AutoContributorSettingsDetails = gql`
  fragment AutoContributorSettingsDetails on AutoContributorSettings {
    upload_access
    dnp_access
    view_access
    album_create_access
    video_upload_access
  }
`;
